import { h, render, Component } from 'preact';


const  QuikrWallet = (props) => (
	<svg id="share" version="1.1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" viewBox="0 0 72 72" class={props.class}>
		<path d="M60.79,64.29H11.21c-2.96,0-5.36-2.41-5.36-5.36V18.48c0-0.02,0-0.04,0-0.07c0-0.05,0-0.1,0-0.15
	c0-3.23,2.63-5.85,5.85-5.85h26.1l8.63-4.57c0.28-0.15,0.61-0.17,0.91-0.07c0.3,0.1,0.54,0.32,0.68,0.61l1.85,4.03h5.83
	c2.96,0,5.36,2.41,5.36,5.36v4.05c2.83,0.14,5.09,2.49,5.09,5.36v31.74C66.15,61.88,63.74,64.29,60.79,64.29z M8.15,22.92v36.01
	c0,1.69,1.37,3.06,3.06,3.06h49.57c1.69,0,3.06-1.37,3.06-3.06v-8.2h-7.46c-4.05,0-7.35-3.3-7.35-7.35s3.3-7.35,7.35-7.35h7.46
	v-8.84c0-1.69-1.37-3.06-3.06-3.06h-7.32c-0.02,0-0.03,0-0.05,0H20.35c-0.01,0-0.03,0-0.05,0h-8.6
	C10.37,24.12,9.14,23.67,8.15,22.92z M56.39,38.33c-2.78,0-5.05,2.26-5.05,5.05s2.27,5.05,5.05,5.05h7.46v-10.1H56.39z M54.18,21.82
	h4.58v-4.04c0-1.69-1.37-3.06-3.06-3.06h-4.77L54.18,21.82z M24.95,21.82h26.69l-5.21-11.37l-7.61,4.03
	c-0.1,0.08-0.22,0.14-0.34,0.18L24.95,21.82z M11.7,14.71c-1.96,0-3.55,1.59-3.55,3.55s1.59,3.55,3.55,3.55h8.34l13.42-7.1H11.7z
	 M56.93,44.44h-0.26c-0.64,0-1.15-0.52-1.15-1.15s0.51-1.15,1.15-1.15h0.26c0.64,0,1.15,0.52,1.15,1.15S57.57,44.44,56.93,44.44z"/>
	</svg>
);

export default QuikrWallet;


// WEBPACK FOOTER //
// ../q-components/components/icons/drawerIcons/wallet/index.js